import axios from 'axios'

import api from '@/lib/api'

function setAuthTokenHeader(token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

export default {
  namespaced: true,
  state: {
    userDetails: {
      userId: null,
      name: null,
      image: null,
      token: null,
      email: null,
    },
    passwordRecoveryDetails: {
      ReturnCode: null,
      ResponseMessage: null,
    },
    newsletterDetails: {
      ReturnCode: null,
      ResponseMessage: null,
    },
    responseRegister: {
      ReturnCode: null,
      ResponseMessage: null,
    },
    responseContactUs: {
      ReturnCode: null,
      ResponseMessage: null,
    },
    responseChatMenu: null,
    messages: null,
    Id: null
  },
  mutations: {
    setUserDetails(state, user) {
      state.userDetails = user;
      //console.log('user ::::::::::: ', user.id);
      if(user && user.id > 0){
        localStorage.setItem('user', JSON.stringify(user))
      }
      else {
        localStorage.setItem('user', null)
      }
      
    },
    setContactUsDetails(state, res) {
      state.responseContactUs = res;
    },
    setPasswordRecoveryDetails(state, res) {
      state.passwordRecoveryDetails = res;
    },
    setNewsletterDetails(state, res) {
      state.newsletterDetails = res;
    },
    setResponseRegister(state, res) {
      state.responseRegister = res;
    },
    setChatMenu(state, responseChatMenu) {
      state.responseChatMenu = responseChatMenu;
    },
    setMessage(state, messages) {
      state.messages = messages;
    },
    setChatId(state, Id) {
      state.Id = Id;
    }
  },
  getters: {
    isAuthenticated(state, getters) {
      return getters.currentUser != null
    },
    currentUser(state) {
      if(state.userDetails == null || state.userDetails.token == null) {

        if (localStorage.user == null) {
          return null
        }

        let user = JSON.parse(localStorage.user)
        state.userDetails = user
        return state.userDetails
      }

      return state.userDetails;
    }
  },
  actions: {
    async login({ commit }, { login, password }) {
     // const response = 
     const response =  await api.login(login, password);
     //console.log('response response :: ', response.status)

      if(response.status == 200)
      {
        setAuthTokenHeader(response.data.access_token)
        const userDetailsResponse = await api.userDetails()
        commit('setUserDetails', {
          id: userDetailsResponse.data.UserId,
          name: userDetailsResponse.data.Name,
          image: userDetailsResponse.data.ImageURL,
          token: response.data.access_token,
          email: userDetailsResponse.data.Email,
        })
      }
      else
      {
         commit('setUserDetails', null)
      }
     
    },
    async register({ commit }, { login, password, name, mobile, category }) {
      const response = await api.register(login, password, name, mobile, category);
      console.log('response register :: ', response);
      commit('setResponseRegister', {
        ReturnCode: response.data.ReturnCode,
        ResponseMessage: response.data.ResponseMessage,
      })

    },
    async passwordRecovery({ commit }, { email }) {
      const response = await api.passwordRecovery(email);
      //console.log('response :::::::::::::: ', response);
      commit('setPasswordRecoveryDetails', {
        ReturnCode: response.data.ReturnCode,
        ResponseMessage: response.data.ResponseMessage,
      })
    },
    async contactUs({ commit }, { name,email,message }) {
      const response = await api.contactUs(name,email,message);
      console.log('response contact us :::::::::::::: ', response);
      //console.log('response :::::::::::::: ', response);
      commit('setContactUsDetails', {
        ReturnCode: response.data.ReturnCode,
        ResponseMessage: response.data.ResponseMessage,
      })
    },
    async addEmailNewsletter({ commit }, { email }) {
      const response = await api.addEmailNewsletter(email);
      
      commit('setNewsletterDetails', {
        ReturnCode: response.data.ReturnCode,
        ResponseMessage: response.data.ResponseMessage,
      })
    },
    singOut({ commit }) {
      commit('setUserDetails', null)
    },
    async fetchChatMenuSession({ commit }, { FromUserId }) {
      const response = await api.ChatMenu(FromUserId);
      commit('setChatMenu', response.data.Result)
    },
    async fetchMessage({ commit }, { ChatId, StaffStatus }) {
      const response =  await api.MessageList(ChatId, StaffStatus);
      commit('setMessage', response.data.list)      
    },
    async addNewChat({ commit }, { Title, ToTenantId, MessageBody, FromUserId }) {
      const response = await api.addNewChat(Title, ToTenantId, MessageBody, FromUserId);
      commit('setChatId', {
        Id : response.data.Id,
      })
    },
    async updateChat({ commit },{ChatId, MessageBody, FromUserId, StaffStatus}) {
      const response = await api.updateChat(ChatId, MessageBody, FromUserId, StaffStatus)
    }
    
  }
}
